<template>
  <div v-if="current_profile.type !== PROFILE_TYPES.CUSTOMER && is_bounced">
    <p class="help is-danger">
      <VPopper v-if="!show_description">
        <template #tip>
          {{ $t(`profile.validation.emailAddressBounce.${profile.attributes.email_address_status}`) }}
        </template>
        <template #content>
          <span class="font-bold">
            <FontAwesomeIcon :icon="['fa', 'triangle-exclamation']" />
            {{ $t('profile.validation.emailAddressBounced') }}
          </span>
        </template>
      </VPopper>
      <span
        v-else
        class="font-bold"
      >
        <FontAwesomeIcon :icon="['fa', 'triangle-exclamation']" /> {{ $t('profile.validation.emailAddressBounced') }}
      </span>
      <span v-if="show_description">
        <br />{{ $t(`profile.validation.emailAddressBounce.${profile.attributes.email_address_status}`) }}
      </span>
    </p>
    <br />
  </div>
</template>

<script>
import { EMAIL_ADDRESS_STATUSES, PROFILE_TYPES } from '@/app/data/model_constants';
import { mapGetters } from 'vuex';

export default {
  name: 'EmailAddressStatusIndicator',
  props: {
    profile: { type: Object, required: true },
    show_description: { type: Boolean, default: false },
  },

  data() {
    return {
      PROFILE_TYPES,
    };
  },

  computed: {
    ...mapGetters(['current_profile']),
    is_bounced() {
      return _.includes(
        [
          EMAIL_ADDRESS_STATUSES.STATUS_HARD_BOUNCE,
          EMAIL_ADDRESS_STATUSES.STATUS_SOFT_BOUNCE,
          EMAIL_ADDRESS_STATUSES.STATUS_SPAM_COMPLAINT,
          EMAIL_ADDRESS_STATUSES.STATUS_SPAM_NOTIFICATION,
          EMAIL_ADDRESS_STATUSES.STATUS_ISP_BLOCK,
          EMAIL_ADDRESS_STATUSES.STATUS_ILLEGAL_ADDRESS,
        ],
        this.profile.attributes.email_address_status,
      );
    },
  },
};
</script>
